import React, { useEffect, useState } from "react";
import API, { LIST_RANK, LIST_REWARD_CLAIM } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { 
    Radio,
    Table,
    Spin,
    Pagination,
} from "antd";

const TEXT = {
    username: "Tên đăng nhập",
    turn: "Số lượt đã chơi",
    rank: "Thứ hạng",
    isFake: "Là người chơi fake",
}

const RankList = () => {
    const auth = JSON.parse(localStorage.getItem("auth"));

    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const locale = {
        emptyText: TEXT_DEF.text0035,
    };
    const [loading, setLoading] = useState(false);

    const [indexTab, setIndexTab] = useState(1);
    const [dataListHis, setDataListHis] = useState([]);

    const onChangeTab = (e) => {
        setPage(1);
        setIndexTab(e.target.value);
    };

    const dataColums = auth?.role === "super_admin" ? 
        [
            {
                title: TEXT.rank,
                align: "center",
                key: "order",
                render: (text, record, index) => (
                    <span>{(page - 1) * 10 + (index + 1)}</span>
                ),
            },
            {
                title: TEXT_DEF.text0002,
                dataIndex: "username",
                key: "username",
            },
            {
                title: TEXT.turn,
                key: "usedTurns",
                dataIndex: "usedTurns",
            },
            {
                title: TEXT.isFake,
                key: "isFake",
                render: (text, record,) => (
                    <span>{record.isFake ? "Tài khoản fake" : ""}</span>
                ),
            },
        ]:
        [
            {
                title: TEXT.rank,
                align: "center",
                key: "order",
                render: (text, record, index) => (
                    <span>{(page - 1) * 10 + (index + 1)}</span>
                ),
            },
            {
                title: TEXT_DEF.text0002,
                dataIndex: "username",
                key: "username",
            },
            {
                title: TEXT.rank,
                key: "usedTurns",
                dataIndex: "usedTurns",
            },
        ];


    const dataColumsHis = [
        {
            title: "STT",
            align: "center",
            key: "order",
            render: (text, record, index) => (
                <span>{(page - 1) * 10 + (index + 1)}</span>
            ),
        },
        {
            title: TEXT_DEF.text0002,
            dataIndex: "username",
            key: "username",
        },
        {
            title: "Số điểm đã nhận",
            key: "amount",
            dataIndex: "amount",
        },
        {
            title: TEXT.rank,
            key: "rank",
            dataIndex: "rank",
        },
    ] 

    const showTotal = (total) => `Tổng cộng ${total} dữ liệu`;

    useEffect(() => {
        if (indexTab === 1) {
            getListDataRank()
        } else {
            getListDataHistoryClaim();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, indexTab]);

    const getListDataRank = async () => {
        setLoading(true);
        const dataList1 = API.get(
            `${LIST_RANK}?pageSize=10&page=${page}`
        );

        await Promise.all([dataList1])
            .then((response) => {
                const res = response[0].data.data.data;
                if (res) {
                    let dataCV = [];
                    res?.forEach((item, index) => {
                        const user = {
                            key: item?.id,
                            username: item?.username,
                            usedTurns: item?.playCount,
                            isFake: item?.isFake,
                            rank: index + 1,
                        };
                        dataCV.push(user);
                    });

                    setDataList(dataCV);
                    setTotalRecord(response[0].data?.data?.total);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const getListDataHistoryClaim = async () => {
        setLoading(true);
        const dataList1 = API.get(
            `${LIST_REWARD_CLAIM}?pageSize=100&page=${page}`
        );

        await Promise.all([dataList1])
            .then((response) => {
                const res = response[0].data.data.data;
                if (res) {
                    let dataCV = [];
                    res?.forEach((item) => {
                        const user = {
                            key: item?.id,
                            username: item?.username,
                            amount: item?.amount,
                            rank: item?.rank,
                        };
                        dataCV.push(user);
                    });

                    setDataListHis(dataCV);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const onChangePage = (page) => {
        setPage(page);
    };

    const renderTableUser = () => {
        return (
            <Spin spinning={loading} delay={500} size="large">
                <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
                    <Table
                        key="table-user-fake"
                        locale={locale}
                        columns={dataColums}
                        dataSource={dataList}
                        pagination={false}
                        bordered
                        style={{ width: "100%" }}
                    />
                </div>
                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        marginTop: 15,
                        justifyContent: "flex-end",
                    }}
                >
                    <Pagination
                        current={page}
                        total={totalRecord}
                        onChange={onChangePage}
                        defaultPageSize={10}
                        showSizeChanger={false}
                        showTotal={showTotal}
                    />
                </div>
            </Spin>
        )
    }

    const renderTableHis = () => {
        return (
            <Spin spinning={loading} delay={500} size="large">
                <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
                    <Table
                        key="table-history-claim"
                        locale={locale}
                        columns={dataColumsHis}
                        dataSource={dataListHis}
                        pagination={false}
                        bordered
                        style={{ width: "100%" }}
                    />
                </div>
            </Spin>
        )
    }

    return (
        <div className="col-12">
            {auth?.role === "super_admin" ? (
                <div
                    className="col-12"
                    style={{
                        borderBottom: "1px solid #CCC",
                        paddingBottom: "2rem",
                        marginBottom: "2rem",
                    }}
                >
                    <Radio.Group value={indexTab} onChange={onChangeTab}>
                        <Radio.Button value={1}>Bảng xếp hạng</Radio.Button>
                        <Radio.Button value={2}>Lịch sử nhận điểm</Radio.Button>
                    </Radio.Group>
                </div>
            ) : null}
            {indexTab === 1 ? renderTableUser() : renderTableHis()}
        </div>
    );
};

export default RankList;
